module.exports = __webpack_public_path__ + "operace-ocnich-vicek-horni_2_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-ocnich-vicek-horni_2_after.jpg
// module id = 1159
// module chunks = 0